/**
 * The admin cloud pages that page modules link to, as the `{ _route, _leaf }` pair
 * routesData.js carries for each. routesData.js spreads these into its tree and adds the
 * labels and permissions, so a page reads its links from here without importing the
 * whole route table.
 *
 * Only routes a page module links to belong here. The rest stay in routesData.js, so
 * adding a route there changes no page's import closure.
 */
import { routeUnder } from './routeUnder';

const aws = routeUnder('/admin/aws');
const azure = routeUnder('/admin/azure');
const gcp = routeUnder('/admin/gcp');
const vmware = routeUnder('/admin/vmware');

export const AWS_ROUTES = {
  savingsPlans: aws('savings-plans'),
  waste: aws('waste'),
  trackedRecommendations: aws('tracked-recommendations'),
  spend: aws('spend'),
  pausing: aws('pausing'),
  pausingRecommendations: aws('pausing-recommendations'),
  riPlanner: aws('ri-planner'),
  riManagement: aws('ri-management'),
  unusedInstances: aws('unused-instances'),
  upgradeRecommendations: aws('upgrade-recommendations'),
  inventory: aws('inventory'),
};

export const AZURE_ROUTES = {
  riPlanner: azure('ri-planner'),
  waste: azure('waste'),
  riManagement: azure('ri-management'),
  unusedInstances: azure('unused-instances'),
  upgradeRecommendations: azure('upgrade-recommendations'),
  pausing: azure('pausing'),
  pausingRecommendations: azure('pausing-recommendations'),
  spend: azure('spend'),
  trackedRecommendations: azure('tracked-recommendations'),
  inventory: azure('inventory'),
};

export const GCP_ROUTES = {
  riPlanner: gcp('ri-planner'),
  waste: gcp('waste'),
  pausing: gcp('pausing'),
  pausingRecommendations: gcp('pausing-recommendations'),
  unusedInstances: gcp('unused-instances'),
  upgradeRecommendations: gcp('upgrade-recommendations'),
  trackedRecommendations: gcp('tracked-recommendations'),
  spend: gcp('spend'),
  inventory: gcp('inventory'),
};

export const VMWARE_ROUTES = {
  unusedInstances: vmware('unused-instances'),
  inventory: vmware('inventory'),
};
